var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');
require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');



// require('jquery.placeholder');
// require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
require('magnific-popup');
// require('lazysizes');
//require('picturefill');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    var headerOffset = $('#main-nav').outerHeight();

    $('#wrapper').css('margin-top', headerOffset + 'px');

    $(window).on('resize', function() {

        var headerOffset = $('#main-nav').outerHeight();
        $('#wrapper').css('margin-top', headerOffset + 'px');

    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 50) {
            $('#main-nav').addClass('shrink-nav');
        } else {
            $('#main-nav').removeClass('shrink-nav');
        }
    });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    

    $('.pop').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        disableOn: function() {
            if ($(window).width() < 600) {
                return false;
            }
            return true;
        }
    });

    

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').on('click', function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('btn-close')

    });

   



    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            smartSpeed: 700,
            // animateOut: 'fadeOut',
            // animateIn: 'fadeIn', 
            // mouseDrag:false,
            // touchDrag:false,
            // pullDrag:false,
            // freeDrag:false,
            
        })
    }


    if ($('.gallery-slider').length) {
        $('.gallery-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            smartSpeed: 700,
            // animateOut: 'fadeOut',
            // animateIn: 'fadeIn', 
            // mouseDrag:false,
            // touchDrag:false,
            // pullDrag:false,
            // freeDrag:false,
            
        })
    }

    if ($('.carousel-4-column').length) {
        $('.carousel-4-column').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 32,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 4000,
            smartSpeed: 1000,
                responsive : {
             
                0 : {
                    items:1,
                },
                // breakpoint from 480 up
                480 : {
                    items:2,
                },
                // breakpoint from 768 up
                992 : {
                    items:3,
                    autoplay: false, 
                    mouseDrag:false,
                    touchDrag:false,
                    pullDrag:false,
                    freeDrag:false,
                }
            }
        })
    }

    if ($('.testimonial-carousel').length) {
        $('.testimonial-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 12000,
            smartSpeed: 750

        })
    }

    setTimeout(() => {
        scrollToAnchor();
    }, 500)

    // if ($('.down-scroll').length) {
    //         // Page scroll
    //         $('.down-scroll').bind('click', function(event) {
    //             scrollToElement(this);
    //             event.preventDefault();

    //         });

    //         $('.down-scroll').each(function() {
    //             var hash = window.location.hash;
    //             var anchor = this;

    //             if (hash == this.hash) {
    //                 scrollToElement(anchor);
    //             }

    //             $(window).on('hashchange', function (e) {
    //                 e.preventDefault();
    //                 var hash = window.location.hash;
    //                 if (hash == anchor.hash) {
    //                     scrollToElement(anchor);
    //                 }
    //             })
    //         })
    //     }

})

// scroll window to form error element and offset fixed header height
function scrollToAnchor() {
    // console.log('scrollToAnchor', window.location.hash);
    var windowWidth = $(window).width();
    
    var scrollTo = '#';
    if (window.location.hash && window.location.hash.indexOf(scrollTo) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());


            if (windowWidth > 992) {
                var offsetSize = $('#header').height() + 120;
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            } else {
                var offsetSize = $('#header').height() + 70;
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            }
        }
    }
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js